import {
  BARCODE_GEN_CONFIG_SET,
  DROPLIST_CONFIG_SET,
  PICKLIST_CONFIG_SET,
} from "../types";

const initialState = {
  picklistEnabled: false,
  dropListEnabled: false,
  barcodeGen: false,
};
const picklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case PICKLIST_CONFIG_SET:
      console.log("PICKLIST_CONFIG_SET", action.data);
      return { ...state, picklistEnabled: action.data };
    case DROPLIST_CONFIG_SET:
      console.log("DROPLIST_CONFIG_SET", action.data);
      return { ...state, dropListEnabled: action.data };
    case BARCODE_GEN_CONFIG_SET:
      return { ...state, barcodeGen: action.data };
    default:
      return state;
  }
};

export default picklistReducer;